export default {
  methods: {

    flatFieldState(field) {
      return this.$v[field].$dirty ? !this.$v[field].$error : null;
    },

    fieldState(form, field) {
      return this.$v[form][field].$dirty ? !this.$v[form][field].$error : null;
    },

    isValid(form) {
      return !this.$v[form].$invalid;
    },
  },
};
